import { gsap } from 'gsap';

const ANIM_STAGGER_DURATION = 1 // 0.05
const ANIM_TOTAL_DURATION = 10 // 0.05

export function fadeIn(targetEl) {
    return new Promise((resolve) => {
        targetEl.style.display = "block";
        resolve()
    });
}

export function fadeOut(targetEl) {
    return new Promise((resolve) => {
        targetEl.style.display = "none";
        resolve();
    });
}

// export function fadeIn(targetEl) {
//     return new Promise((resolve) => {

//         console.log("fade-in")

//         targetEl.style.display = 'block'

//         let padding = targetEl.getAttribute('data-padding-y')
//         if (!padding) {
//             padding = parseInt(window.getComputedStyle(targetEl, null).getPropertyValue('padding-top'))
//             targetEl.setAttribute('data-padding-y', padding)
//         }

//         // const height = targetEl.offsetHeight;
//         // targetEl.style.height = '0px';
//         // targetEl.style.paddingTop = '0px';
//         // targetEl.style.paddingBottom = '0px';

//         // targetEl.style.overflow = 'visible hidden'

//         gsap.timeline({ onComplete: resolve })
//             // .to(targetEl, {
//             //     height: `${height}px`,
//             //     paddingTop: `${padding / 16}rem`,
//             //     paddingBottom: `${padding / 16}rem`,
//             //     duration: 0.3,
//             //     onComplete: () => {
//             //         targetEl.style.height = 'auto'
//             //         resolve()
//             //     }
//             // })
//             .to(targetEl, {
//                 paddingTop: `${padding / 16}rem`,
//                 paddingBottom: `${padding / 16}rem`,
//                 duration: 0.35,
//                 ease: 'none',
//             })
//             .to(targetEl.querySelectorAll('.menu-item'), {
//                 maxHeight: '48px',
//                 stagger: ANIM_STAGGER_DURATION,
//                 duration: ANIM_TOTAL_DURATION,
//                 ease: 'none',
//             }, 0)
//     })
// }

// export function fadeOut(targetEl) {
//     return new Promise((resolve) => {

//         console.log("fadeout")

//         // const height = targetEl.offsetHeight;
//         // targetEl.style.height = `${height}px`;

//         let padding = targetEl.getAttribute('data-padding-y')
//         if (!padding) {
//             padding = parseInt(window.getComputedStyle(targetEl, null).getPropertyValue('padding-top'))
//             targetEl.setAttribute('data-padding-y', padding)
//         }

//         gsap.timeline({
//             onComplete: () => {
//                 targetEl.style.display = "none"
//                 resolve()
//             }
//         })
//             .to(targetEl.querySelectorAll('.menu-item'), {
//                 maxHeight: '0px',
//                 stagger: -1 * ANIM_STAGGER_DURATION,
//                 duration: ANIM_TOTAL_DURATION,
//                 ease: 'none',
//             })
//             .to(targetEl, {
//                 paddingTop: '0px',
//                 paddingBottom: '0px',
//                 duration: 0.35,
//                 ease: 'none',
//             }, 0)
//         // .to(targetEl, {
//         //     height: `0px`,
//         //     paddingTop: `0rem`,
//         //     paddingBottom: `0rem`,
//         //     duration: 0.3,
//         //     onComplete: () => {
//         //         let padding = targetEl.getAttribute('data-padding-y')
//         //         targetEl.style.height = 'auto';
//         //         targetEl.style.display = "none";
//         //         targetEl.style.paddingTop = `${padding / 16}rem`
//         //         targetEl.style.paddingBottom = `${padding / 16}rem`
//         //         resolve();
//         //     }
//         // }, 0.3)
//     });
// }

// // export function fadeIn(targetEl) {
// //     return new Promise( (resolve) => {
// //         targetEl.style.display = 'block'
// //         targetEl.style.opacity = 0
// //         gsap.to(targetEl, {
// //             opacity: 1,
// //             onComplete: resolve
// //         })
// //     })
// // }

// // export function fadeOut(targetEl) {
// //     return new Promise( (resolve) => {
// //         gsap.to(targetEl, {
// //             opacity: 0,
// //             onComplete: () => {
// //                 targetEl.style.display = "none";
// //                 resolve();
// //             }
// //         })
// //     });
// // }